import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import logo from '../../assets/img/bsm-logo.png';
import logoSingle from '../../assets/img/bsm-logo-single.png';
import Header from '../../components/angle/Header';
import Login from './Login/screens';

class LoginPanel extends Component {
    render() {
        const { history } = this.props;
        return (
            <div className="wrapper">
                <Header
                    logo={logo}
                    logoSingle={logoSingle}
                    history={history}
                />
                <div className="content-wrapper">
                    <Route
                        exact
                        path='/'
                        component={Login}
                    />
                    <Route
                        exact
                        path='/login'
                        component={Login}
                    />
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(LoginPanel));



// WEBPACK FOOTER //
// ./src/screens/LoginPanel/index.js